import _ from 'lodash'

import { LevelPlayQuestion as Activity } from '.'

const normalizeComparableValue = value =>
  _.toString(value ?? '')
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const buildRegexFromValue = value => {
  if (_.isNil(value)) return null
  const stringValue = _.toString(value)
  if (!stringValue) return null

  try {
    if (stringValue.startsWith('/') && stringValue.lastIndexOf('/') > 0) {
      const pattern = stringValue.slice(1, stringValue.lastIndexOf('/'))
      const flags = stringValue.slice(stringValue.lastIndexOf('/') + 1) || 'i'
      return new RegExp(pattern, flags)
    }

    return new RegExp(stringValue, 'i')
  } catch (err) {
    console.warn('Invalid regex pattern for answer rule', err)
    return null
  }
}

const evaluateRule = ({ rule, normalizedAnswer, rawAnswer }) => {
  const kind = rule?.kind || 'equals'
  const normalizedRuleValue = normalizeComparableValue(rule?.value)

  switch (kind) {
    case 'equals':
      return normalizedAnswer === normalizedRuleValue
    case 'contains':
      return normalizedAnswer.includes(normalizedRuleValue)
    case 'not_equals':
      return normalizedAnswer !== normalizedRuleValue
    case 'match_pattern': {
      const regex = buildRegexFromValue(rule?.value)
      if (!regex) return false
      return regex.test(_.toString(rawAnswer ?? ''))
    }
    default:
      return false
  }
}

const evaluateAnswerRules = ({ groups = [], answer }) => {
  if (!groups?.length) return null

  const sanitizedGroups = groups
    .filter(group => !group?._destroy)
    .map(group => ({
      ...group,
      answer_rules: (group?.answer_rules || []).filter(rule => !rule?._destroy)
    }))
    .filter(group => group.answer_rules.length)

  if (!sanitizedGroups.length) return null

  const normalizedAnswer = normalizeComparableValue(answer)
  const rawAnswer = _.toString(answer ?? '')

  return sanitizedGroups.some(group =>
    group.answer_rules.every(rule =>
      evaluateRule({ rule, normalizedAnswer, rawAnswer })
    )
  )
}

export const KINDS = {
  QR_CODE: 'qr_code',
  TEXT: 'text',
  MULTIPLE_CHOICE: 'multiple_choice'
}
const SLUG = 'question'
export const activity = {
  SLUG,
  Component: Activity,
  handleAnswerCallback: props => {
    let { answer, activity } = props
    let {
      save_answer: saveAnswer = false,
      question_kind: questionKind = KINDS.TEXT,
      alternatives = [],
      answer: correctAnswer = '',
      answer_rules_groups: answerRulesGroups = []
    } = activity.meta
    const kind = questionKind || KINDS.TEXT
    if (kind == KINDS.MULTIPLE_CHOICE)
      correctAnswer = alternatives
        .filter(alt => alt.is_correct)
        .map(alt => alt.name)
        .sort()
    if (_.isArray(answer)) answer = answer.sort()
    const normalizedCorrectAnswer = normalizeComparableValue(correctAnswer)
    const normalizedAnswer = normalizeComparableValue(answer)

    const rulesResult =
      kind === KINDS.TEXT
        ? evaluateAnswerRules({ groups: answerRulesGroups, answer })
        : null

    const fallbackComparison = normalizedCorrectAnswer === normalizedAnswer

    const answerIsCorrect =
      typeof rulesResult === 'boolean' ? rulesResult : fallbackComparison

    return { answer, answerIsCorrect, skipValidation: saveAnswer }
  }
}
